import {
    createVNode as _$cv,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Input} from './';
import {Icon} from '../icon';
import {Button} from '../button';
import {getRestProps} from '../utils';
import {makeSearchStyles} from './styles';

var _$tmp0 = {
    'className': 'k-icon-search k-search-icon'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        className, placeholder, value,
        type, size, open, 
    } = this.get();
    
    const isTypeNotDefault = type !== 'default';
    
    const classNameObj = {
        'k-search': true,
        [className]: className,
        'k-open': open,
        'k-hide': !open,
        [`k-${type}`]: isTypeNotDefault,
        [makeSearchStyles()]: true,
    };
    
    return _$cv('form', {
        ...getRestProps(this),
        'className': _$cn(classNameObj),
        'ev-submit': this.onSubmit,
        'ref': this.elementRef
    }, [
        _$cc(Input, {
            'clearable': true,
            'ref': this.inputRef,
            'placeholder': open ? placeholder : undefined,
            'value': open ? value : undefined,
            'ev-$change:value': this.onChangeValue,
            'readonly': !open,
            'size': size,
            'className': 'k-with-suffix',
            'waveDisabled': isTypeNotDefault
        }, null, this.inputRef),
        _$cc(Button, {
            'icon': true,
            'type': 'none',
            'ev-click': this.onClickBtn,
            'size': size,
            'children': (
                _$cc(Icon, _$tmp0)
            )
        })
    ]);
};